interface PhoneNumberValidationSuccess {
  isValid: true;
}
interface PhoneNumberValidationFail {
  isValid: false;
  error: string;
}
/**
 * 휴대폰 번호 유효성 검사 결과
 */
export type PhoneNumberValidation = PhoneNumberValidationSuccess | PhoneNumberValidationFail;

/**
 * 휴대폰 번호 포맷팅 (3-4-4)
 * @param input - 입력된 문자열
 * @returns 포맷팅된 휴대폰 번호
 */
export const formatPhoneNumber = (input: string): string => {
  // 숫자만 추출
  const numbers = input.replace(/\D/g, '');

  // 최대 11자리까지만
  const truncated = numbers.slice(0, 11);

  // 3-4-4 패턴으로 포맷팅
  if (truncated.length > 7) {
    return truncated.replace(/^(\d{3})(\d{4})(\d{1,4}).*$/, '$1-$2-$3');
  }
  if (truncated.length > 3) {
    return truncated.replace(/^(\d{3})(\d{1,4}).*$/, '$1-$2');
  }
  return truncated;
};

/**
 * 휴대폰 번호에서 숫자만 추출
 * @param input - 포맷팅된 휴대폰 번호
 * @returns 숫자만 포함된 문자열
 */
export const deformatPhoneNumber = (input: string): string => {
  return input.replace(/\D/g, '');
};

/**
 * 휴대폰 번호 유효성 검사
 * - 10~11자리 길이 확인
 *
 * @param value - 휴대폰 번호 (10-11자리 숫자 문자열)
 * @returns 유효성 검사 결과
 *
 * @example
 * validatePhoneNumber('0101234') // { isValid: false, error: '휴대폰 번호 형식이 올바르지 않습니다' }
 * validatePhoneNumber('01012345678') // { isValid: true }
 */
export const validatePhoneNumber = (value: string): PhoneNumberValidation => {
  const numbers = deformatPhoneNumber(value);

  if (numbers.length === 0) {
    return { isValid: false, error: '' };
  }

  // 10-11자리 검증
  if (numbers.length < 10) {
    return { isValid: false, error: '휴대폰 번호 형식이 올바르지 않습니다' };
  }

  if (numbers.length === 10 || numbers.length === 11) {
    return { isValid: true };
  }

  return { isValid: false, error: '휴대폰 번호 형식이 올바르지 않습니다' };
};
